/**
 * drlh-parallax.js
 * Parallax for [data-parallax] wrappers containing an inner <img> or <picture>.
 * Inner image is oversized via CSS (top:-20%; height:140%! — set globally in
 * assets/brand-tokens.css) so its edges never show.
 * Drift = 14% of image height, which stays inside the 20% overhang.
 * Transform-only, rAF-throttled. Respects prefers-reduced-motion.
 * Safe to load multiple times — idempotent via a window flag.
 */
(function () {
  if (window.__drlhParallaxInit) return;
  window.__drlhParallaxInit = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var FRACTION = 0.14;
  var ticking = false;
  /* Cached. querySelectorAll used to run inside update(), i.e. once per scroll
     frame, and every getBoundingClientRect read after it forced a fresh layout.
     The list only changes when the DOM does, so refresh it on those events. */
  var imgs = [];

  function update() {
    var vh = window.innerHeight;
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var wrap = img.parentElement;
      if (!wrap) continue;
      var box = wrap.getBoundingClientRect();
      if (box.bottom < 0 || box.top > vh) continue;
      var center = box.top + box.height / 2;
      var ratio = (center - vh / 2) / (vh / 2 + box.height / 2);
      var y = Math.max(-1, Math.min(1, ratio)) * -(box.height * FRACTION);
      img.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }

  function refresh() {
    imgs = Array.prototype.slice.call(document.querySelectorAll('[data-parallax] img'));
    onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', refresh, { passive: true });
  /* Theme editor add/remove/reorder swaps whole sections in and out. */
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);

  refresh();
})();
